import React from "react";

const PageNotFound = () => (
	<div className="row flex-xl-nowrap">
	    <section id="not-found" className="notFoundPage">
		    <div id="title"></div>
		    <div className="circles">
		      <p>404<br/>
		       <small>PAGE NOT FOUND</small>
		      </p>
		      <span className="circle big"></span>
		      <span className="circle med"></span>
		      <span className="circle small"></span>
		    </div>
		  </section>
	  </div>
);

export default PageNotFound;
